module.exports = "<div fxLayout=\"column\">\n    <app-header flex></app-header>\n    <div class=\"boxed-content-wrapper\">\n        <app-homescreen></app-homescreen>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/homepage/homepage.component.html
// module id = ../../../../../src/app/agatextscreens/homepage/homepage.component.html
// module chunks = 0